import React from "react";

function Hero() {
    return (
        <div className="container-fluid mb-5" id="supportHero">
            <div className="pt-5 pb-5 mt-5" id="supportWrapper">

                <h4>Support Protal</h4>
                <a href="">Track Ticket</a>
            </div>

            <div className="row mx-5">
                <div className="col-6 px-5">
                    <h3 className="mb-5 fs-3">Search for an answer or browse help topics to create a ticket</h3>
                    <input className="form-control mb-3" type="search" placeholder="Eg. how do i activate F%Q, why is my order getting rejected" />

                    <a href="">Track account opening</a>
                    <a href="">Track segment activation</a>
                    <a href="">Intraday margins</a>
                    <a href="">Kite user manual</a>

                </div>
                <div className="col-6 px-5">
                    <h1>Featured</h1>
                    <ol>
                        <li>
                            <a href="">Quarterly Settlement of Funds - July 2025</a>

                        </li>
                        <li>
                           <a href=""> Exclusion of F&O contracts on 8 securities from August 29, 2025</a>

                        </li>
                    </ol>


                </div>

            </div>
        </div>

    );
}

export default Hero;